import { useSyncExternalStore } from "react";
import { pwaUpdateModel, type PwaUpdateSnapshot } from "@/features/pwa-update/pwa-update.model";

const SERVER_SNAPSHOT = { updater: null, dismissed: false } as const satisfies PwaUpdateSnapshot;

export const usePwaUpdate = (): PwaUpdateSnapshot =>
  useSyncExternalStore(
    pwaUpdateModel.subscribe,
    () => pwaUpdateModel.snapshot,
    () => SERVER_SNAPSHOT,
  );
